import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'timezone'

  static get fields () {
    return {
      id: new UUID(),
      zone: new STRING()
    }
  }
}
